
import { appLanguage } from '@/config/app'
import { appLocaleKey } from '@/util/storeKey'

const state = {
  appContext: process.env.VUE_APP_CONTEXT,
  appCode: process.env.VUE_APP_CODE,
  appDebugger: false,
  appLanguage: localStorage.getItem(appLocaleKey) || appLanguage || navigator.language || navigator.browserLanguage,
}


const mutations = {
	updateLanguage(state, payload) {
		state.appLanguage = payload
    localStorage.setItem(appLocaleKey, payload)
		document.querySelector('html').setAttribute('lang', payload)
	},
}
const actions = {
	async setLanguage({ commit, state, dispatch, rootState }, payload) {
		commit('updateLanguage', payload)
    console.log(state, dispatch, rootState);
    
	},
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
